import { ReactNode } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { HighlightedText } from '@/components/lemmala-design-system/highlighted-text/highlighted-text'

export type TitleSubtitleCellParams = {
  title: string
  subtitle: string
  titleHighlights?: { start: number; end: number }[]
  subtitleHighlights?: { start: number; end: number }[]
  titleSuffix?: ReactNode
  leading?: ReactNode
  subtitleClassName?: string
}

export const TitleSubtitleCell = ({
  title,
  subtitle,
  titleHighlights = [],
  subtitleHighlights = [],
  titleSuffix,
  leading,
  subtitleClassName,
}: TitleSubtitleCellParams) => {
  return (
    <div className='relative flex min-w-0 items-center gap-2'>
      <div className='flex min-w-0 flex-1 flex-col gap-1'>
        <div className='flex min-w-0 items-center gap-1.5'>
          {leading}
          <HighlightedText
            text={title || ''}
            highlights={titleHighlights}
            className='min-w-0 truncate text-main-foreground-primary text-label-default'
          />
          {titleSuffix}
        </div>
        <div className='-mt-0.5 truncate text-nowrap'>
          <HighlightedText
            text={subtitle || ''}
            highlights={subtitleHighlights}
            className={cn(
              'block max-w-md truncate text-main-foreground-secondary text-body-small',
              subtitleClassName,
            )}
          />
        </div>
      </div>
    </div>
  )
}
